export default __webpack_public_path__ + "static/blog-img12-a9cedc8b996fb826cc0fac4add54cc1a.jpg";